import DOMPurify from 'dompurify'

function updateComponent (el, binding) {
  const currentValue = binding.value
  if (binding.oldValue === currentValue) { return }
  el.innerHTML = DOMPurify.sanitize(currentValue)
}

const SafeHtml = {
  /**
   * @param {import('vue').App} Vue
   * @param {any} options
   */
  install (Vue, options) {
    Vue.directive('safe-html', {
      inserted: updateComponent,
      update: updateComponent,
      unbind: (el) => {
        el.innerHTML = ''
      },
    })
  },
}

export default SafeHtml
